import {url} from "./apiurl";
import {authHeader} from '../_helpers/auth-header';
import {handleResponse} from '../_helpers/resposne-handler';


const login = (data) => {

  const reqOptions = {
     method:"POST",
     headers:{"Content-Type":"application/json"},
     body: JSON.stringify(data)
  }

  return fetch(`${url}/user/login`,reqOptions)
    .then(handleResponse)
    .then(data =>{
      if(data.token)
        sessionStorage.setItem("accessToken", JSON.stringify(data.token));
        sessionStorage.setItem("user", JSON.stringify(data.user));
      return data;
    })
}

const register = (data) => {

  const reqOptions = {
     method:"POST",
     headers:{"Content-Type":"application/json"},
     body: JSON.stringify(data)
  }

  return fetch(`${url}/user/register`,reqOptions)
    .then(handleResponse)
}

const reset = (data) => {

  const reqOptions = {
     method:"POST",
     headers:{"Content-Type":"application/json"},
     body: JSON.stringify(data)
  }

  return fetch(`${url}/auth/customer/reset-password`,reqOptions)
    .then(handleResponse)
}

const update = (data) => {

  const reqOptions = {
     method:"POST",
     headers:{"Content-Type":"application/json"},
     body: JSON.stringify(data)
  }

  return fetch(`${url}/auth/customer/update-password`,reqOptions)
    .then(handleResponse)
}


export const authService = {  login,  register,reset,update }
